/* eslint-disable no-nested-ternary */
import React, { Component, Fragment } from 'react';
import { Redirect } from 'react-router-dom';

import classNames from 'classnames';

import api from '../../../services/api';
import errorMessage from '../../../config/errorMessages';
import validate from '../../../services/briefing/validate';
import QuestionData from '../QuestionData';
import QuestionTitle from '../QuestionTitle';

import NotGraphic from '../NotGraphic';

import './style/step.scss';

import loader from '../../../img/icon-loading.gif';

export default class Step extends Component {
	static IsJsonString(str) {
		try {
			JSON.parse(str);
		} catch (e) {
			return false;
		}
		return true;
	}

	apiResponseData = JSON.parse(localStorage.getItem('step-data'));

	constructor(props) {
		super(props);
		this.getValueField = this.getValueField.bind(this);
		this.scrollRef = React.createRef();
	}

	state = {
		responseApiLoginAccount: '',
		classResponse: '',
		fieldDisable: false,
		token: '',
		substep: 1,
		substeps: 0,
		filial: [0],
		ended: false,
		errorMessagesApi: '',
	};

	componentWillMount() {
		const dataPath = Step.getDataFromPath();
		this.getStepFromApi(dataPath.briefing, dataPath.step);

		this.setState({
			formQuestions: this.getQuestionsData(),
			step: this.getStepData(),
			briefingId: this.apiResponseData.id,
		});
	}

	static getDataFromPath = () => {
		const info = [];
		window.location.pathname
			.substring(1)
			.split('/')
			.map((content, index, array) => {
				if (!Number(content)) {
					info[content] = array[index + 1];
				}
				return content;
			});
		return info;
	};

	onSubmit = (e) => {
		e.preventDefault();
		this.resetValidationStates();

		if (this.formIsValid()) {
			this.handleIncreaseSubsteps();
		}
	};

	onBack = (e) => {
		e.preventDefault();
		this.resetValidationStates();
		this.handleDecreaseSubsteps();
	};

	getAnswerData = (questionId) => {
		const answer = this.apiResponseData.relationships.answers.find(
			ans => ans.relationships.question.data.id === questionId,
		);
		let ans = '';
		if (typeof answer !== 'undefined' && answer.attributes.content !== 'null') {
			if (Step.IsJsonString(answer.attributes.content)) {
				ans = JSON.parse(answer.attributes.content);
			} else {
				ans = answer.attributes.content;
			}
		}

		return ans;
	};

	/**
	 *
	 * @todo A alteração das questões neste pedaço do estado é um
	 * candidato ao uso de um helper de imutabilidade para melhoria de performance.
	 * @param name
	 * @param value
	 * @param isValid
	 */
	getValueField = (name, value, isValid = true) => {
		let { formQuestions } = this.state;
		const questions = Object.assign(formQuestions);
		formQuestions = questions.map((question) => {
			if (question.nameField === name) {
				question.valueField = isValid ? value : '';
			}
			return question;
		});
		this.setState({ formQuestions });
	};

	getAnswersFromAliasToAlias(questionaAlias) {
		const aliasNeedAnswersFromAlias = { locale_box: 'shop' };
		const alias = aliasNeedAnswersFromAlias[questionaAlias];
		return alias ? this.findAnswerByMeta('alias', alias) : '';
	}

	scrollToRef = () => {
		window.scrollTo(0, this.scrollRef.current.offsetTop);
	};

	changeFilial = (valueFilial) => {
		const { filial } = this.state;

		filial.push(valueFilial + 1);

		this.setState({
			filial,
		});
	};

	removeFilial = (valueFilial) => {
		let { filial } = this.state;
		const index = filial.indexOf(valueFilial);

		if (valueFilial === 0) {
			return false;
		}

		if (index > -1) {
			filial.splice(index, 1);

			filial = filial.filter(data => data !== index);
		}

		return this.setState({
			filial,
		});
	};

	resetFields = (fields) => {
		fields.map((field) => {
			field.isValid = false;
			field.messageErrorField = '';
			return field;
		});
	};

	resetValidationStates = () => {
		const state = JSON.parse(JSON.stringify(this.state));

		const hasBarProperty = Object.prototype.hasOwnProperty.call(state, 'isValid');

		Object.keys(state).map((key) => {
			if (hasBarProperty) {
				state[key].isValid = true;
				state[key].messageErrorField = '';
			}
			return state[key];
		});

		return this.setState(state);
	};

	conditionsToRequired = (question) => {
		let required = question.required;

		if (typeof question.meta.conditional_required_checkbox !== 'undefined') {
			const {
				formQuestions,
			} = this.state;

			const fieldToCheck = question.meta.conditional_required_checkbox.alias;
			const valueToCheck = question.meta.conditional_required_checkbox.value;
			const questionToCheck = formQuestions.filter(qst => qst.meta.alias === fieldToCheck)[0];

			required = (Array.isArray(questionToCheck.valueField)
				&& questionToCheck.valueField.includes(valueToCheck));
		}

		return (
			required
			&& Array.isArray(question.valueField)
			&& question.valueField.length === 0
		) || (
				required
				&& !Array.isArray(question.valueField)
				&& !question.valueField
			) || (
				required
				&& Array.isArray(question.valueField)
				&& !question.valueField.toString().replace(/(\(|\)|-|\s)/g, '')
			);
	};

	formIsValid = () => {
		const {
			formQuestions,
		} = this.state;

		let isGood = true;
		this.resetFields(formQuestions);

		formQuestions.map((question) => {
			if (this.conditionsToShow(question) && this.conditionsToRequired(question)) {
				question.isValid = false;
				question.messageErrorField = errorMessage.REQUIRED_FIELD;
				isGood = isGood && question.isValid;
			}

			if (validate.isEmailField(question)) {
				question = validate.emailByQuestion(question);
				isGood = isGood && question.isValid;
			}

			if (question.typeField === 'plan-fields') {
				question = validate.planQuestion(question);
				isGood = isGood && question.isValid;
			}

			if (question.typeField === 'open-checkbox') {
				question = validate.openCheckbox(question);
				isGood = isGood && question.isValid;
			}

			if (question.typeField === 'open-radio-input') {
				question = validate.openRadioInput(question);
				isGood = isGood && question.isValid;
			}

			if (typeof question.meta !== 'undefined' && question.meta.alias === 'link_divulgacao') {
				question = validate.forDisclosureOnGoogle(question);
				isGood = isGood && question.isValid;
			}

			return question;
		});

		this.setState({
			formQuestions,
			formInvalid: !isGood,
		});

		return isGood;
	};

	nextStep = () => {
		const that = this;

		const {
			step,
			briefingId,
			formQuestions,
		} = this.state;

		const data = formQuestions.map(question => ({
			id: question.id,
			value: typeof question.valueField !== 'string' ? JSON.stringify(question.valueField) : question.valueField,
		}));

		that.setState({
			responseApiLoginAccount: '',
			fieldDisable: true,
			errorMessagesApi: '',
		});

		this.saveStepOnApi(data, briefingId, step.id);
	};

	prevStep = () => {
		const {
			prevStepId,
			briefingId,
		} = this.state;
		if (briefingId) {
			this.getStepFromApi(briefingId, prevStepId, () => {
				const { step } = this.state;
				let { substeps, substep } = this.state;
				const position = parseInt(step.position, 10);
				if (position === 7) {
					substeps = 2;
					substep = 2;
				}
				this.setState({
					substeps,
					substep,
				}, () => { this.scrollToRef(); });
			});
		}
	};

	nextStep100GoogleSearch = () => {
		const that = this;

		const {
			step,
			briefingId,
		} = this.state;

		const data = [30, 31, 32, 33, 34, 35, 36, 37].map(id => ({ id, value: '' }));

		that.setState({
			responseApiLoginAccount: '',
			fieldDisable: true,
			errorMessagesApi: '',
		});

		this.saveStepOnApi(data, briefingId, step.id);
	};

	saveStepOnApi = (data, briefingId, stepId) => {
		api.post(`/briefings/${briefingId}/steps/${stepId}`, data)
			.then((response) => {
				if (response.data.success === true) {
					this.setState({ ended: true });
				} else {
					this.apiResponseData = response.data;
					this.setState({
						formQuestions: this.getQuestionsData(),
						step: this.getStepData(),
						prevStepId: stepId,
						briefingId: this.apiResponseData.id,
						classResponse: 'success',
						fieldDisable: false,
						substep: 1,
					}, () => { this.scrollToRef(); });
				}
			})
			.catch((e) => {
				this.setErrorMessageFromApi(e);
				this.setState({
					fieldDisable: false,
				});
			});
	};

	getStepFromApi = (briefingId, stepId, callback = null) => {
		api.get(`/briefings/${briefingId}/steps/${stepId}`)
			.then((response) => {
				this.apiResponseData = response.data.data;
				const questionsData = this.getQuestionsData();
				this.setState({
					step: this.getStepData(),
					formQuestions: questionsData,
					briefingId: this.apiResponseData.id,
					prevStepId: this.apiResponseData.prev_step_id,
					nextStepId: this.apiResponseData.next_step_id,
					classResponse: 'success',
					errorMessagesApi: '',
					fieldDisable: false,
				});
				if (typeof callback === 'function') {
					callback();
				}
			})
			.catch((e) => {
				this.setErrorMessageFromApi(e);
			});
	};

	setErrorMessageFromApi = (error) => {
		if (!error.response) {
			this.setState(
				prevState => (
					{ errorMessagesApi: `${prevState.errorMessagesApi} Tivemos um problema, tente mais tarde.` }
				),
			);
			return false;
		}

		const errorMessages = error.response.data.errors;

		if (typeof errorMessages === 'object') {
			errorMessages.forEach((content) => {
				this.setState(
					prevState => (
						{ errorMessagesApi: prevState.errorMessagesApi + content.message }
					),
				);
			});
		}

		return false;
	};

	onChange = (e) => {
		const { formQuestions } = this.state;
		const questions = Object.assign(formQuestions);
		const questionsUp = questions.map((question) => {
			if (question.nameField === e.target.name) {
				const element = e.target;
				let value = '';
				let arrayValues = [];
				switch (element.type) {
					case 'checkbox':
					case 'stock-checkbox':
						if (typeof question.valueField !== 'undefined' && question.valueField !== '') {
							arrayValues = question.valueField;
						}
						if (element.checked) {
							arrayValues.push(element.value);
						} else {
							arrayValues.splice(arrayValues.indexOf(element.value), 1);
						}
						value = arrayValues;
						break;
					default:
						value = element.value;
				}
				question.valueField = value;
			}

			return question;
		});

		this.setState({
			formQuestions: questionsUp,
		});
	};

	getStepData = () => {
		if (!this.apiResponseData) {
			return false;
		}
		const step = this.apiResponseData.relationships.step;
		return {
			id: step.id,
			title: step.attributes.title,
			position: step.attributes.position,
			prevStepId: step.attributes.prev_step_id,
			isLast: step.attributes.is_last,
		};
	};

	getQuestions = () => {
		if (!this.apiResponseData) {
			return false;
		}
		return this.apiResponseData.relationships.step.relationships.questions;
	};

	getQuestionsData = (
		formResponseData = this.apiResponseData,
	) => {
		if (this.getQuestions()) {
			return this.getQuestions().map(question => ({
				id: question.id,
				title: question.attributes.title,
				typeField: question.relationships.question_types.data.attributes.field_type,
				nameField: `q${question.id}_b${formResponseData.id}`,
				required: question.attributes.required,
				placeholderField: '',
				valueField: this.getAnswerData(question.id),
				disabledField: false,
				messageErrorField: '',
				classField: 'form-control toggle-password',
				classContainer: question.attributes.meta.class_container,
				options: question.attributes.options,
				meta: question.attributes.meta,
				isValid: true,
			}));
		}
		return false;
	};

	handleIncreaseSubsteps = () => {
		const { step, formQuestions } = this.state;
		let { substep } = this.state;
		let substeps = 0;
		const position = parseInt(step.position, 10);

		if (position === 6) {
			const questionToCheck = formQuestions
				.find(qst => qst.meta.alias === 'escolha_peca_grafica');

			if (typeof questionToCheck !== 'undefined' && questionToCheck.valueField.includes('Sim, eu quero!')) {
				substeps = 3;
			} else {
				substeps = 2;
			}
		}
		if (substeps > 0 && substep < substeps) {
			substep += 1;
			return this.setState({
				substep,
				substeps,
			}, () => this.scrollToRef());
		}
		return this.nextStep();
	};

	lastOfLast = () => {
		const { step } = this.state;

		return step.isLast;
	};

	handleDecreaseSubsteps = () => {
		const { step } = this.state;
		let { substep } = this.state;
		let substeps = 0;
		const position = parseInt(step.position, 10);

		if (position === 6) {
			substeps = 3;
		}
		if (substeps > 0 && substep > 1) {
			substep -= 1;
			return this.setState({
				substeps,
				substep,
			}, () => this.scrollToRef());
		}
		return this.prevStep();
	};

	findAnswerByMeta = (meta, value) => {
		const answers = this.apiResponseData.relationships.answers;
		return answers.filter(ans => ans.relationships.question.data.attributes.meta[meta] === value);
	};

	conditionsToShow = (question) => {
		const { substep } = this.state;
		const metaConditionalSubstep = question.meta.conditional_substep;
		if (typeof metaConditionalSubstep !== 'undefined'
			&& typeof metaConditionalSubstep !== 'object'
			&& metaConditionalSubstep !== substep) {
			return false;
		}
		if (typeof metaConditionalSubstep !== 'undefined' && typeof metaConditionalSubstep === 'object') {
			const { formQuestions } = this.state;
			const conditionalSubstepQuestion = formQuestions
				.find(qst => qst.meta.alias === metaConditionalSubstep.alias);

			if (
				conditionalSubstepQuestion.valueField.includes(metaConditionalSubstep.value)
				&& substep !== metaConditionalSubstep.substep) {
				return false;
			}

			if (!conditionalSubstepQuestion.valueField.includes(metaConditionalSubstep.value)
				&& substep !== metaConditionalSubstep.default) {
				return false;
			}
		}

		if (typeof question.meta.conditional_rendering !== 'undefined') {
			if (question.meta.conditional_rendering.same_step) {
				const { formQuestions } = this.state;
				const sameStepQuestion = formQuestions
					.find(qst => (qst.meta.alias === question.meta.conditional_rendering.alias));
				return (sameStepQuestion.valueField.includes(question.meta.conditional_rendering.value));
			}
			const answer = this.findAnswerByMeta('alias', question.meta.conditional_rendering.alias);
			if (typeof answer[0] !== 'undefined' && answer[0].attributes.content.includes(question.meta.conditional_rendering.value)) {
				return true;
			}
			return false;
		}
		return true;
	};

	render() {
		const {
			fieldDisable,
			formInvalid,
			formQuestions,
			step,
			filial,
			ended,
			errorMessagesApi,
		} = this.state;

		if (!this.apiResponseData) {
			return <Redirect to={{ pathname: '/briefing' }} />;
		}

		if (ended) {
			return <Redirect to={{ pathname: '/obrigado' }} />;
		}

		return (
			<Fragment>
				<picture ref={this.scrollRef}>
					<source srcSet={`/images/status/mobile/${step.position}.svg`} media="(max-width: 480px)" />

					<img src={`/images/status/${step.position}.svg`} className="w-80 mb-5 status" alt={`status${step.position}`} />
				</picture>

				<QuestionTitle titleStep={step.title} />

				{
					(step.position === 6 && this.getAnswerData('22').googleSearch.percent === '100%') ? (
						<div className="component-step">
							<NotGraphic />

							<div className={step.position === 1 ? 'group-buttons single-button' : 'group-buttons'}>
								{step.position === 1 ? ''
									: (
										<button
											type="button"
											className="btn btn-light"
											disabled={fieldDisable}
											onClick={this.onBack.bind(this)}
										>
											{fieldDisable ? <img src={loader} alt="Carregando!" /> : 'Voltar'}
										</button>
									)
								}
								<button
									type="submit"
									className="btn btn-success"
									disabled={fieldDisable}
									onClick={this.nextStep100GoogleSearch.bind(this)}
								>
									{fieldDisable ? <img src={loader} alt="Carregando!" /> : this.lastOfLast() ? 'Enviar' : 'Próximo'}
								</button>
							</div>
						</div>
					) : (
						<form className="component-step">
							{formQuestions.map(
									(question) => {
										if (this.conditionsToShow(question)) {
											return (
												<QuestionData
													key={question.nameField}
													question={question.title}
													typeField={question.typeField}
													nameField={question.nameField}
													placeholderField={question.placeholderField}
													valueField={question.valueField}
													onGetValueField={this.getValueField}
													messageErrorField={question.messageErrorField}
													classField={`${question.classField} ${(formInvalid && question.messageErrorField !== '') ? 'is-invalid' : ''}`}
													classContainer={`${question.classContainer} ${classNames('form-group', { 'has-error': !question.isValid })}`}
													onChangeField={this.onChange}
													options={question.options}
													meta={question.meta}
													answers={this.getAnswersFromAliasToAlias(question.meta.alias)}
													questions={formQuestions}
													required={question.required}
													filial={filial}
													changeFilial={this.changeFilial}
													removeFilial={this.removeFilial}
												/>
											);
										}
										return null;
									},
								)}
							<div className="help-block">{errorMessagesApi || ''}</div>
							<div className={step.position === 1 ? 'group-buttons single-button' : 'group-buttons'}>
								{step.position === 1 ? ''
										: (
											<button
												type="button"
												className="btn btn-light"
												disabled={fieldDisable}
												onClick={this.onBack.bind(this)}
											>
												{fieldDisable ? <img src={loader} alt="Carregando!" /> : 'Voltar'}
											</button>
										)
									}
								<button
									type="submit"
									className="btn btn-success"
									disabled={fieldDisable}
									onClick={this.onSubmit.bind(this)}
								>
									{fieldDisable ? <img src={loader} alt="Carregando!" /> : this.lastOfLast() ? 'Enviar' : 'Próximo'}
								</button>
							</div>
						</form>
						)}
			</Fragment>
		);
	}
}
